(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mayas-floating-video"] && !Shopify.designMode) return;
  try {
    
    class FloatingVideo extends HTMLElement {
      connectedCallback() {
        this.pill = this.querySelector('[data-fv-open]');
        this.dialog = this.querySelector('[data-fv-dialog]');
        this.dialogVideo = this.querySelector('[data-fv-dialog-video]');
        this.form = this.querySelector('[data-fv-form]');
        this.variantEl = this.querySelector('[data-fv-variant]');
        this.priceEl = this.querySelector('[data-fv-price]');
        this.addBtn = this.querySelector('[data-fv-add]');
        this.errEl = this.querySelector('[data-fv-err]');
        this.loaded = false;

        if (!this.pill || !this.dialog) return;

        this.pill.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-fv-close]').forEach((el) =>
          el.addEventListener('click', () => this.dialog.close())
        );
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.onClose());

        if (this.variantEl) {
          this.variantEl.addEventListener('change', () => this.syncPrice());
        }
        if (this.form) {
          this.form.addEventListener('submit', (e) => this.addToCart(e));
        }
      }

      open() {
        if (!this.loaded) {
          const src = this.dialogVideo.getAttribute('data-fv-src');
          if (src) {
            const source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            this.dialogVideo.appendChild(source);
            this.dialogVideo.load();
          }
          this.loaded = true;
        }
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        const play = this.dialogVideo.play();
        if (play && play.catch) play.catch(() => {});
      }

      onClose() {
        this.dialogVideo.pause();
        if (this.pill) this.pill.focus();
      }

      syncPrice() {
        let price = '';
        if (this.variantEl.tagName === 'SELECT') {
          const opt = this.variantEl.options[this.variantEl.selectedIndex];
          if (opt) price = opt.getAttribute('data-price');
        } else {
          price = this.variantEl.getAttribute('data-price');
        }
        if (price && this.priceEl) this.priceEl.textContent = price;
      }

      async addToCart(e) {
        e.preventDefault();
        if (this.errEl) this.errEl.hidden = true;
        const id = this.variantEl ? this.variantEl.value : null;
        if (!id) return;
        this.addBtn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
          });
          if (!res.ok) throw new Error('add failed');
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
          const drawerToggle = document.querySelector('[aria-controls="cart-drawer"]');
          this.dialog.close();
          if (drawerToggle) {
            drawerToggle.click();
          } else {
            window.location.href = '/cart';
          }
        } catch (err) {
          if (this.errEl) this.errEl.hidden = false;
          window.location.href = '/cart';
        } finally {
          this.addBtn.removeAttribute('aria-busy');
        }
      }
    }
    if (!customElements.get('floating-video')) {
      customElements.define('floating-video', FloatingVideo);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-atc"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* ----------------------------------------------------------------
     Variant hidden input update - ATC form syncs to size selection
  ---------------------------------------------------------------- */
  function initAtcVariantSync() {
    var hiddenInput = document.getElementById('mayas-v2-variant-id');
    var btnLabel    = document.getElementById('mayas-v2-atc-btn-label');
    var btnPrice    = document.getElementById('mayas-v2-atc-btn-price');
    var atcBtn      = document.getElementById('mayas-v2-atc-btn');
    var stickySize  = document.getElementById('mayas-v2-sticky-size');
    var klarnaText  = document.getElementById('mayas-v2-klarna-text');

    document.addEventListener('mayas-v2:variant-change', function(e) {
      var detail  = e.detail || {};
      var variant = detail.variant || {};
      if (!variant.id) return;

      /* Update hidden form input */
      if (hiddenInput) hiddenInput.value = variant.id;

      /* Reflect stock state on ATC root so the delivery chip can hide on preorder */
      var atcRootEl2 = document.getElementById('mayas-v2-atc');
      if (atcRootEl2 && variant.state) {
        atcRootEl2.setAttribute('data-stock-state', variant.state);
      }

      /* Update button label based on variant state. Strings come from
         data-label-* attrs on the ATC root, populated by Liquid `| t`
         at render time. */
      if (atcBtn && btnLabel) {
        var atcRootEl = document.getElementById('mayas-v2-atc');
        var isPreorderProduct = atcRootEl ? atcRootEl.getAttribute('data-preorder') === 'true' : false;
        var labelOos      = atcRootEl ? (atcRootEl.getAttribute('data-label-sold-out')  || '') : '';
        var labelPreorder = atcRootEl ? (atcRootEl.getAttribute('data-label-pre-order') || '') : '';
        var labelAdd      = atcRootEl ? (atcRootEl.getAttribute('data-label-add')       || '') : '';

        if (variant.state === 'out') {
          btnLabel.textContent = labelOos;
          atcBtn.classList.add('mayas-v2-atc__btn--oos');
          atcBtn.setAttribute('aria-disabled', 'true');
        } else if (variant.state === 'preorder' || isPreorderProduct) {
          btnLabel.textContent = labelPreorder;
          atcBtn.classList.remove('mayas-v2-atc__btn--oos');
          atcBtn.removeAttribute('aria-disabled');
        } else {
          btnLabel.textContent = labelAdd;
          atcBtn.classList.remove('mayas-v2-atc__btn--oos');
          atcBtn.removeAttribute('aria-disabled');
        }
      }

      var atcRoot = document.getElementById('mayas-v2-atc');
      var shopLocale = atcRoot ? (atcRoot.getAttribute('data-shop-locale') || 'en') : 'en';
      var shopCurrency = atcRoot ? (atcRoot.getAttribute('data-shop-currency') || 'DKK') : 'DKK';

      /* Btn price prefers variant.price_formatted (Liquid-rendered, locale-correct).
         For derived numbers (Klarna quarter, bundle math) we have no Liquid equivalent,
         so we format via Intl.NumberFormat with shop-locale + shop-currency from the
         data-attrs above. Shopify.formatMoney is not used - see
         theme-knowledge/bugs/money-formatting-via-liquid.md. */
      function toFormatted(cents) {
        try {
          return new Intl.NumberFormat(shopLocale, {
            style: 'currency',
            currency: shopCurrency
          }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2) + ' ' + shopCurrency;
        }
      }

      /* Update button price */
      if (btnPrice) {
        if (variant.price_formatted) {
          btnPrice.textContent = variant.price_formatted;
        } else if (variant.price) {
          btnPrice.textContent = toFormatted(variant.price);
        }
      }

      /* Update Klarna line. Locale strings come from data-klarna-before / -after
         on the ATC root; only the price changes per variant. */
      if (klarnaText && variant.price) {
        var quarter = Math.round(variant.price / 4);
        var klarnaBefore = atcRoot ? (atcRoot.getAttribute('data-klarna-before') || '') : '';
        var klarnaAfter  = atcRoot ? (atcRoot.getAttribute('data-klarna-after')  || '') : '';
        klarnaText.innerHTML = klarnaBefore + '<b>' + toFormatted(quarter) + '</b>' + klarnaAfter;
      }

      /* Update sticky size label */
      if (stickySize && variant.title) {
        stickySize.textContent = variant.title;
      }
    });
  }

  /* ----------------------------------------------------------------
     Cart add - main variant + currently-selected pad, in one request
     Intercepts both the primary form submit and the sticky ATC click.
  ---------------------------------------------------------------- */
  function addToCart() {
    var form = document.getElementById('mayas-v2-product-form');
    if (!form) return Promise.reject(new Error('no-form'));

    var mainIdEl = document.getElementById('mayas-v2-variant-id');
    if (!mainIdEl || !mainIdEl.value) return Promise.reject(new Error('no-variant'));

    var items = [{ id: mainIdEl.value, quantity: 1 }];

    var pad = window.__mayasV2SelectedPad;
    if (pad && pad.variantId) {
      items.push({ id: pad.variantId, quantity: 1 });
    }

    /* BOGO free item (mayas-v2-pdp-bogo section, 2026-07-11): the native
       Buy X Get Y automatic discount zeroes the cheapest at checkout. */
    var bogo = window.__mayasV2SelectedBogo;
    if (bogo && bogo.variantId) {
      items.push({ id: bogo.variantId, quantity: 1 });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(e) { throw e; });
      return r.json();
    })
    .then(function(data) {
      /* Tell Prestige's cart system to refresh its drawer / notification */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { source: 'mayas-v2-atc' }
      }));
      document.dispatchEvent(new CustomEvent('cart:added', {
        bubbles: true,
        detail: { items: items, response: data }
      }));

      /* Try to open the cart drawer; fall back to /cart page */
      var drawerTrigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (drawerTrigger) {
        drawerTrigger.click();
      } else {
        window.location.href = '/cart';
      }
      return data;
    });
  }

  function initAtcSubmit() {
    var form = document.getElementById('mayas-v2-product-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = document.getElementById('mayas-v2-atc-btn');
      if (btn) btn.setAttribute('aria-busy', 'true');
      addToCart().catch(function(err) {
        console.error('[mayas-v2 ATC]', err);
        window.location.href = '/cart';
      }).then(function() {
        if (btn) btn.removeAttribute('aria-busy');
      });
    });
  }

  /* ----------------------------------------------------------------
     Sticky ATC - show after main ATC button scrolls above viewport
  ---------------------------------------------------------------- */
  function initStickyAtc() {
    var sticky  = document.getElementById('mayas-v2-sticky-atc');
    var trigger = document.getElementById('mayas-v2-atc-btn');
    if (!sticky || !trigger) return;

    var stickyBtn = document.getElementById('mayas-v2-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        stickyBtn.setAttribute('aria-busy', 'true');
        addToCart().catch(function(err) {
          console.error('[mayas-v2 sticky ATC]', err);
          window.location.href = '/cart';
        }).then(function() {
          stickyBtn.removeAttribute('aria-busy');
        });
      });
    }

    var io = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            sticky.classList.add('mayas-v2-sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'false');
          } else {
            sticky.classList.remove('mayas-v2-sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'true');
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );

    io.observe(trigger);
  }

  /* ----------------------------------------------------------------
     Delivery ETA - countdown to daily cutoff + delivered-by date
     All times resolved in browser-local (visitor is DK for Phase 1).
  ---------------------------------------------------------------- */
  function initDeliveryEta() {
    var root = document.getElementById('mayas-v2-eta');
    if (!root) return;
    var cdEl   = document.getElementById('mayas-v2-eta-countdown');
    var dateEl = document.getElementById('mayas-v2-eta-date');
    if (!cdEl || !dateEl) return;

    var cutoffHour   = parseInt(root.getAttribute('data-cutoff-hour'), 10) || 14;
    var businessDays = parseInt(root.getAttribute('data-business-days'), 10) || 3;
    var cdFormat     = root.getAttribute('data-countdown-format') || '{h}h {m}m';
    var locale       = root.getAttribute('data-locale') || 'da';
    var dateLocale   = locale.indexOf('da') === 0 ? 'da-DK' : 'en-GB';

    function isWeekend(d) {
      var day = d.getDay();
      return day === 0 || day === 6;
    }

    function addBusinessDays(d, n) {
      var r = new Date(d.getTime());
      while (n > 0) {
        r.setDate(r.getDate() + 1);
        if (!isWeekend(r)) n--;
      }
      return r;
    }

    function nextBusinessDay(d) {
      var r = new Date(d.getTime());
      do { r.setDate(r.getDate() + 1); } while (isWeekend(r));
      return r;
    }

    function formatCountdown(ms) {
      if (ms < 0) ms = 0;
      var totalMin = Math.floor(ms / 60000);
      var h = Math.floor(totalMin / 60);
      var m = totalMin % 60;
      return cdFormat.replace('{h}', h).replace('{m}', m);
    }

    function formatDate(d) {
      try {
        return d.toLocaleDateString(dateLocale, {
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        });
      } catch (e) {
        return d.toISOString().slice(0, 10);
      }
    }

    function update() {
      var now = new Date();
      var todayCutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0, 0);
      var beforeCutoffWeekday = !isWeekend(now) && (now < todayCutoff);

      var dispatch, cutoff;
      if (beforeCutoffWeekday) {
        dispatch = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        cutoff   = todayCutoff;
      } else {
        dispatch = nextBusinessDay(now);
        cutoff   = new Date(dispatch.getFullYear(), dispatch.getMonth(), dispatch.getDate(), cutoffHour, 0, 0, 0);
      }

      var delivery = addBusinessDays(dispatch, businessDays);
      cdEl.textContent   = formatCountdown(cutoff.getTime() - now.getTime());
      dateEl.textContent = formatDate(delivery);
    }

    update();
    /* Refresh every minute so countdown stays live. */
    setInterval(update, 60 * 1000);
  }

  /* Fit-finder CTA opens Wair - polls for the Wair-injected button
     (rendered in section mayas-v2-pdp-wair below). 10s deadline matches snippets/wair.liquid. */
  function initFitFinderCta() {
    var ffBtn = document.getElementById('mayas-v2-fit-finder-cta');
    if (!ffBtn) return;
    ffBtn.addEventListener('click', function() {
      /* Same Wair-unavailable fallback as the variants find-size chip:
         poll 4s for the Wair-injected button, then open the size-guide
         page rather than doing nothing (Wair origin-gates theme-dev and
         its load endpoint can 400 on live). */
      var deadline = Date.now() + 4000;
      (function tryOpen() {
        var w = document.getElementById('wair-fit-advisor');
        if (w) { w.click(); return; }
        if (Date.now() < deadline) { window.requestAnimationFrame(tryOpen); return; }
        var g = document.querySelector('.mayas-v2-variants__guide-link');
        if (g && g.getAttribute('href') && g.getAttribute('href') !== '#') window.location.href = g.href;
      })();
    });
  }

  /* Contribe badge_embed pill viewport-aware relocation.
     The badge_placement_selector ('.mayas-v2-atc__apps, .product-info .buy-buttons')
     resolves via document-order first-match. Prestige's .buy-buttons is earlier in
     DOM than .mayas-v2-atc__apps, so Contribe injects there. On mobile the Prestige
     main-product is hidden by the viewport gate (see mayas-v2-pdp-hero.liquid),
     so the pill renders inside a display:none ancestor and is invisible. Since
     2026-07-06 Prestige is hidden at every width, so the pill is always moved
     into .mayas-v2-atc__apps (the visible v2 slot). */
  function initContribePillRelocator() {
    var slot = document.querySelector('.mayas-v2-atc__apps');
    if (!slot) return;
    /* 2026-07-06: Prestige main-product is now hidden at ALL widths (v2 is the
       single PDP), so the pill's first-match target is always inside a
       display:none ancestor — relocate on every viewport, not just mobile. */

    function tryMove() {
      var badge = document.querySelector('[id^="contribe_badge_"]');
      if (!badge) return false;
      if (slot.contains(badge)) return true;
      slot.appendChild(badge);
      return true;
    }

    if (tryMove()) return;

    var observer = new MutationObserver(function() {
      if (tryMove()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAtcVariantSync();
      initAtcSubmit();
      initStickyAtc();
      initDeliveryEta();
      initFitFinderCta();
      initContribePillRelocator();
    });
  } else {
    initAtcVariantSync();
    initAtcSubmit();
    initStickyAtc();
    initDeliveryEta();
    initFitFinderCta();
    initContribePillRelocator();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-bogo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-bogo]');
  if (!root) return;

  var toggle = root.querySelector('#mayas-v2-bogo-toggle');
  var body = root.querySelector('#mayas-v2-bogo-body');
  var status = root.querySelector('#mayas-v2-bogo-status');
  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-bogo-row]'));
  var defaultStatus = status ? status.textContent : '';

  function clearSelection() {
    window.__mayasV2SelectedBogo = null;
    rows.forEach(function (r) { r.classList.remove('mayas-v2-bogo__row--selected'); });
    if (status) status.textContent = defaultStatus;
  }

  function selectRow(row) {
    var sel = row.querySelector('.mayas-v2-bogo__size');
    var opt = sel.options[sel.selectedIndex];
    if (!opt || opt.disabled) return;
    rows.forEach(function (r) { r.classList.remove('mayas-v2-bogo__row--selected'); });
    row.classList.add('mayas-v2-bogo__row--selected');
    window.__mayasV2SelectedBogo = { variantId: opt.value };
    if (status) {
      status.textContent = row.querySelector('.mayas-v2-bogo__row-name').textContent.trim() + ' · ' + opt.text.trim();
    }
  }

  toggle.addEventListener('click', function () {
    var on = root.classList.toggle('mayas-v2-bogo--on');
    toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
    body.hidden = !on;
    if (on) {
      /* Preselect the first available row so one tap is a complete choice */
      var first = rows.filter(function (r) {
        var s = r.querySelector('.mayas-v2-bogo__size');
        return s.options[s.selectedIndex] && !s.options[s.selectedIndex].disabled;
      })[0];
      if (first) selectRow(first);
    } else {
      clearSelection();
    }
  });

  rows.forEach(function (row) {
    row.querySelector('[data-bogo-pick]').addEventListener('click', function () { selectRow(row); });
    row.querySelector('.mayas-v2-bogo__size').addEventListener('change', function () {
      if (row.classList.contains('mayas-v2-bogo__row--selected')) selectRow(row);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-fabric"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initFabricTabs() {
    var root = document.getElementById('mayas-v2-fabric');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.mayas-v2-fabric__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.mayas-v2-fabric__panel'));
    if (!tabs.length || !panels.length) return;

    function activate(target) {
      tabs.forEach(function(t) {
        var match = t.getAttribute('data-panel') === target;
        t.classList.toggle('mayas-v2-fabric__tab--active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
        t.setAttribute('tabindex', match ? '0' : '-1');
      });
      panels.forEach(function(p) {
        var match = p.getAttribute('data-panel') === target;
        p.classList.toggle('mayas-v2-fabric__panel--active', match);
        if (match) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
      /* Tell initFabricVideos to re-evaluate which video should be playing -
         the previously hidden panel just became visible, and IO won't re-fire
         on its own since the video's geometry didn't change. */
      root.dispatchEvent(new CustomEvent('mayas-v2:fabric-tab-activated', {
        bubbles: true, detail: { target: target }
      }));
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activate(tab.getAttribute('data-panel'));
      });
      tab.addEventListener('keydown', function(e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var currentIndex = tabs.indexOf(document.activeElement);
        if (currentIndex === -1) currentIndex = 0;
        var nextIndex = e.key === 'ArrowRight'
          ? (currentIndex + 1) % tabs.length
          : (currentIndex - 1 + tabs.length) % tabs.length;
        var next = tabs[nextIndex];
        activate(next.getAttribute('data-panel'));
        next.focus();
      });
    });
  }

  /* ----------------------------------------------------------------
     Fabric videos - autoplay loop muted playsinline, lazy-loaded.
     Sources are rendered with data-src so the browser doesn't fetch
     bytes on initial parse. IntersectionObserver hydrates + plays on
     first viewport entry; pauses when scrolled out to save battery.
     Tab switches fire `mayas-v2:fabric-tab-activated` so we can play
     the newly visible panel's video (was display:none → couldn't play).
  ---------------------------------------------------------------- */
  function initFabricVideos() {
    var root = document.getElementById('mayas-v2-fabric');
    if (!root) return;
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-mayas-v2-fabric-video]'));
    if (!videos.length) return;

    function hydrate(video) {
      if (video.dataset.hydrated === '1') return;
      var sources = video.querySelectorAll('source[data-src]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
        sources[i].removeAttribute('data-src');
      }
      video.setAttribute('preload', 'auto');
      video.load();
      video.dataset.hydrated = '1';
    }

    function isPanelVisible(video) {
      var panel = video.closest('.mayas-v2-fabric__panel');
      return panel && !panel.hasAttribute('hidden');
    }

    function tryPlay(video) {
      if (!isPanelVisible(video)) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function() { /* autoplay policy blocked - silent */ });
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            hydrate(v);
            tryPlay(v);
          } else if (v.dataset.hydrated === '1') {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 });
      videos.forEach(function(v) { io.observe(v); });
    } else {
      videos.forEach(function(v) { hydrate(v); tryPlay(v); });
    }

    root.addEventListener('mayas-v2:fabric-tab-activated', function() {
      videos.forEach(function(v) {
        if (isPanelVisible(v)) {
          if (v.dataset.hydrated !== '1') hydrate(v);
          tryPlay(v);
        } else {
          v.pause();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initFabricTabs();
      initFabricVideos();
    });
  } else {
    initFabricTabs();
    initFabricVideos();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* ----------------------------------------------------------------
     Hero carousel - touch/swipe + thumbnail dot sync
  ---------------------------------------------------------------- */
  function initHeroCarousel() {
    const track = document.getElementById('mayas-v2-hero-track');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('.mayas-v2-hero__slide'));
    const thumbs = Array.from(document.querySelectorAll('.mayas-v2-hero__thumb'));
    if (slides.length < 2) return;

    let activeIdx = 0;

    function goTo(idx) {
      if (idx < 0 || idx >= slides.length) return;
      activeIdx = idx;
      track.scrollTo({ left: track.offsetWidth * idx, behavior: 'smooth' });
      slides.forEach(function(s, i) {
        s.classList.toggle('mayas-v2-hero__slide--active', i === idx);
        s.setAttribute('aria-hidden', i !== idx ? 'true' : 'false');
      });
      thumbs.forEach(function(t, i) {
        t.classList.toggle('mayas-v2-hero__thumb--active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    thumbs.forEach(function(btn) {
      btn.addEventListener('click', function() {
        goTo(parseInt(btn.getAttribute('data-thumb-index'), 10));
      });
    });

    document.querySelectorAll('[data-hero-arrow]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        goTo(activeIdx + (btn.getAttribute('data-hero-arrow') === 'next' ? 1 : -1));
      });
    });

    var scrollTimer;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var newIdx = Math.round(track.scrollLeft / track.offsetWidth);
        if (newIdx !== activeIdx) goTo(newIdx);
      }, 80);
    }, { passive: true });

    /* Also update on scroll without smooth snap settling delay for snappy feedback */
    track.addEventListener('scrollend', function() {
      var newIdx = Math.round(track.scrollLeft / track.offsetWidth);
      if (newIdx !== activeIdx) goTo(newIdx);
    }, { passive: true });
  }

  /* ----------------------------------------------------------------
     Rotating micro-quotes - vertical slot rotation
  ---------------------------------------------------------------- */
  function initMicroQuotes() {
    var instances = document.querySelectorAll('.mayas-v2-micro-quotes');
    instances.forEach(function(root) {
      var viewport = root.querySelector('.mayas-v2-micro-quotes__viewport');
      if (!viewport) return;
      var quotes = Array.from(viewport.querySelectorAll('.mayas-v2-micro-quote'));
      if (quotes.length < 2) return;
      var interval = parseInt(root.getAttribute('data-rotation-ms'), 10) || 2000;
      var activeIdx = quotes.findIndex(function(q) {
        return q.classList.contains('mayas-v2-micro-quote--active');
      });
      if (activeIdx < 0) {
        activeIdx = 0;
        quotes[0].classList.add('mayas-v2-micro-quote--active');
      }

      function tick() {
        var current = quotes[activeIdx];
        var nextIdx = (activeIdx + 1) % quotes.length;
        var next = quotes[nextIdx];

        current.classList.remove('mayas-v2-micro-quote--active');
        current.classList.add('mayas-v2-micro-quote--exit');

        void next.offsetWidth;
        next.classList.add('mayas-v2-micro-quote--active');

        setTimeout(function() {
          current.classList.remove('mayas-v2-micro-quote--exit');
        }, 450);

        activeIdx = nextIdx;
      }

      setInterval(tick, interval);
    });
  }

  /* ----------------------------------------------------------------
     Price update on variant change
     Listens for Shopify's variant:change event emitted by
     mayas-v2-pdp-variants section.
  ---------------------------------------------------------------- */
  function initPriceUpdate() {
    var priceEl = document.getElementById('mayas-v2-price');
    if (!priceEl) return;
    var priceMap = {};
    try {
      priceMap = JSON.parse(priceEl.getAttribute('data-prices-by-id') || '{}');
    } catch (e) { priceMap = {}; }
    var shopLocale = priceEl.getAttribute('data-shop-locale') || 'en';
    var shopCurrency = priceEl.getAttribute('data-shop-currency') || 'DKK';
    document.addEventListener('mayas-v2:variant-change', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      if (!variant.available) {
        priceEl.textContent = '';
        return;
      }
      var preformatted = priceMap[variant.id];
      if (preformatted) {
        priceEl.textContent = preformatted;
        return;
      }
      try {
        priceEl.textContent = new Intl.NumberFormat(shopLocale, {
          style: 'currency',
          currency: shopCurrency
        }).format(variant.price / 100);
      } catch (err) {
        priceEl.textContent = (variant.price / 100).toFixed(2) + ' ' + shopCurrency;
      }
    });
  }

  /* ----------------------------------------------------------------
     Title relocator - desktop two-column layout
     On >=768px the title/price/rating block moves to the top of the
     buy column (the variants section, which grid-places into column 2).
     On <768px it returns to its original spot under the gallery.
     Mirrors the initContribePillRelocator pattern in the ATC section.
     The mobile DOM/markup is unchanged - this only fires at desktop width.
  ---------------------------------------------------------------- */
  function initTitleRelocator() {
    var title = document.getElementById('mayas-v2-title');
    if (!title) return;
    var heroWrap = title.parentNode;
    var mq = window.matchMedia('(min-width: 768px)');

    function place(isDesktop) {
      var variants = document.getElementById('mayas-v2-variants');
      if (isDesktop) {
        if (variants && variants.firstChild !== title) {
          variants.insertBefore(title, variants.firstChild);
        }
      } else if (heroWrap && title.parentNode !== heroWrap) {
        heroWrap.appendChild(title);
      }
    }

    place(mq.matches);

    var raf;
    function onChange() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function() { place(mq.matches); });
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initHeroCarousel();
      initMicroQuotes();
      initPriceUpdate();
      initTitleRelocator();
    });
  } else {
    initHeroCarousel();
    initMicroQuotes();
    initPriceUpdate();
    initTitleRelocator();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-pads"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var DATA = {};
  try {
    var dataEl = document.getElementById('mayas-v2-pads-data');
    if (dataEl) { DATA = JSON.parse(dataEl.textContent || '{}'); }
  } catch (e) { DATA = {}; }

  function getRows() {
    var list = document.getElementById('mayas-v2-pads-list');
    return list ? Array.prototype.slice.call(list.querySelectorAll('.mayas-v2-pad')) : [];
  }

  function activeRow() {
    var list = document.getElementById('mayas-v2-pads-list');
    return list ? list.querySelector('.mayas-v2-pad--active') : null;
  }

  /* Push one slot's line-item id + price text into a row (or hide it). */
  function applyRow(row, slot) {
    if (!slot) {
      row.setAttribute('hidden', '');
      return;
    }
    row.removeAttribute('hidden');
    if (slot.id != null) row.setAttribute('data-pad-variant', String(slot.id));

    if (row.getAttribute('data-pad-is-bundle') === 'true') {
      if (slot.was) row.setAttribute('data-bundle-was', slot.was);
      if (slot.now) row.setAttribute('data-bundle-now', slot.now);
      if (slot.save) row.setAttribute('data-bundle-save', slot.save);
      var wasEl = row.querySelector('.mayas-v2-pad__price-was');
      var nowEl = row.querySelector('.mayas-v2-pad__price-now');
      var saveEl = row.querySelector('.mayas-v2-pad__save-tag');
      if (wasEl && slot.was) wasEl.textContent = slot.was;
      if (nowEl && slot.now) nowEl.textContent = '+ ' + slot.now;
      if (saveEl && slot.save) saveEl.textContent = slot.save;
    } else {
      var pWas = row.querySelector('.mayas-v2-pad__price-was');
      if (pWas && slot.price) pWas.textContent = slot.price;
    }
  }

  /* Refresh the collapsed summary from a row's current state. */
  function updateSummary(row) {
    var titleEl = document.getElementById('mayas-v2-pads-summary-title');
    var wasEl = document.getElementById('mayas-v2-pads-summary-was');
    var nowEl = document.getElementById('mayas-v2-pads-summary-now');
    var saveEl = document.getElementById('mayas-v2-pads-summary-save');
    var freeEl = document.getElementById('mayas-v2-pads-summary-free');
    var tagEl = document.getElementById('mayas-v2-pads-tag');
    var isBundle = row.getAttribute('data-pad-is-bundle') === 'true';

    if (titleEl) titleEl.textContent = row.getAttribute('data-pad-name') || '';

    /* Mirror the selected row's image into the collapsed card (desktop). */
    var thumbEl = document.getElementById('mayas-v2-pads-summary-thumb');
    if (thumbEl) {
      var rowImg = row.querySelector('.mayas-v2-pad__thumb-img');
      if (rowImg) {
        var clone = rowImg.cloneNode(true);
        clone.className = 'mayas-v2-pads__summary-thumb-img';
        thumbEl.innerHTML = '';
        thumbEl.appendChild(clone);
      } else {
        thumbEl.innerHTML = '';
      }
    }

    if (isBundle) {
      if (wasEl) { wasEl.textContent = row.getAttribute('data-bundle-was') || ''; wasEl.style.display = ''; }
      if (nowEl) { nowEl.textContent = '+ ' + (row.getAttribute('data-bundle-now') || ''); nowEl.style.display = ''; }
      if (saveEl) { saveEl.textContent = row.getAttribute('data-bundle-save') || ''; saveEl.style.display = ''; }
      if (freeEl) freeEl.style.display = 'none';
      if (tagEl) tagEl.textContent = tagEl.getAttribute('data-tag-bundle') || tagEl.textContent;
    } else {
      if (wasEl) wasEl.style.display = 'none';
      if (nowEl) nowEl.style.display = 'none';
      if (saveEl) saveEl.style.display = 'none';
      if (freeEl) freeEl.style.display = '';
      if (tagEl) tagEl.textContent = tagEl.getAttribute('data-tag-single') || tagEl.textContent;
    }
  }

  /* Mark a row selected; update the global selected-pad + summary + dispatch. */
  function selectRow(row, collapseAfter) {
    getRows().forEach(function(r) {
      r.classList.remove('mayas-v2-pad--active');
      r.setAttribute('aria-checked', 'false');
    });
    row.classList.add('mayas-v2-pad--active');
    row.setAttribute('aria-checked', 'true');

    window.__mayasV2SelectedPad = {
      variantId: row.getAttribute('data-pad-variant'),
      name: row.getAttribute('data-pad-name') || '',
      isBundle: row.getAttribute('data-pad-is-bundle') === 'true'
    };

    updateSummary(row);

    document.dispatchEvent(new CustomEvent('mayas-v2:pad-change', {
      bubbles: true,
      detail: window.__mayasV2SelectedPad
    }));

    if (collapseAfter) {
      var toggle = document.getElementById('mayas-v2-pads-toggle');
      var list = document.getElementById('mayas-v2-pads-list');
      setTimeout(function() {
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (list) list.setAttribute('hidden', '');
      }, 280);
    }
  }

  /* Swap every row to the slot data for the given garment variant id. */
  function applyVariant(variantId) {
    var slots = DATA[String(variantId)];
    if (!slots) return;
    var rows = getRows();
    rows.forEach(function(row) {
      applyRow(row, slots[row.getAttribute('data-pad-key')]);
    });

    var act = activeRow();
    if (!act || act.hasAttribute('hidden')) {
      var firstVisible = rows.filter(function(r) { return !r.hasAttribute('hidden'); })[0];
      if (firstVisible) selectRow(firstVisible, false);
    } else {
      /* Re-select so the size-correct line-item id + summary stay current. */
      selectRow(act, false);
    }
  }

  function init() {
    var root = document.getElementById('mayas-v2-pads');
    if (!root) return;
    var toggle = document.getElementById('mayas-v2-pads-toggle');
    var list = document.getElementById('mayas-v2-pads-list');
    var rows = getRows();
    if (!toggle || !list || !rows.length) return;

    /* Seed selection from the server-rendered active row. */
    var act = activeRow() || rows[0];
    selectRow(act, false);

    /* Sync to the current variant (handles ?variant= deep links + size-correct ids). */
    var input = document.getElementById('mayas-v2-variant-id');
    if (input && input.value) applyVariant(input.value);

    /* Collapse / expand */
    toggle.addEventListener('click', function() {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (isOpen) { list.setAttribute('hidden', ''); }
      else { list.removeAttribute('hidden'); }
    });

    /* Row selection */
    rows.forEach(function(row) {
      row.addEventListener('click', function() { selectRow(row, true); });
    });

    /* Swap pad data when the garment variant changes. */
    document.addEventListener('mayas-v2:variant-change', function(e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.id) return;
      applyVariant(v.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-perf"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initPerfSlider(slider) {
    var clip    = slider.querySelector('[data-perf-clip]');
    var divider = slider.querySelector('[data-perf-divider]');
    if (!clip || !divider) return;

    var pos = 50;
    var dragging = false;

    function setPos(percent) {
      percent = Math.max(0, Math.min(100, percent));
      pos = percent;
      slider.style.setProperty('--perf-pos', percent + '%');
    }

    function pointerToPercent(clientX) {
      var rect = slider.getBoundingClientRect();
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    function onDown(e) {
      dragging = true;
      divider.setPointerCapture && e.pointerId && divider.setPointerCapture(e.pointerId);
      setPos(pointerToPercent(e.clientX));
      e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;
      setPos(pointerToPercent(e.clientX));
    }

    function onUp() {
      dragging = false;
    }

    divider.addEventListener('pointerdown', onDown);
    divider.addEventListener('pointermove', onMove);
    divider.addEventListener('pointerup', onUp);
    divider.addEventListener('pointercancel', onUp);
    divider.addEventListener('click', function(e) { e.preventDefault(); });
  }

  function initPerfCarousel(carousel) {
    var rail = carousel.querySelector('[data-perf-rail]');
    var prev = carousel.querySelector('[data-perf-prev]');
    var next = carousel.querySelector('[data-perf-next]');
    if (!rail || !prev || !next) return;

    function step() {
      var card = rail.querySelector('.mayas-v2-perf-card');
      if (!card) return rail.clientWidth * 0.8;
      var styles = getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      prev.disabled = rail.scrollLeft <= 0;
      next.disabled = rail.scrollLeft >= max;
    }

    prev.addEventListener('click', function() {
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', function() {
      window.requestAnimationFrame(update);
    });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-perf-slider]'))
      .forEach(initPerfSlider);
    Array.prototype.slice
      .call(document.querySelectorAll('.mayas-v2-perf__carousel'))
      .forEach(initPerfCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-variants"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* ----------------------------------------------------------------
     Size grid - variant selection + cross-section event dispatch
  ---------------------------------------------------------------- */
  function initSizeGrid() {
    var grid = document.getElementById('mayas-v2-size-grid');
    if (!grid) return;
    var btns = Array.from(grid.querySelectorAll('.mayas-v2-size'));
    if (!btns.length) return;

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId     = btn.getAttribute('data-variant-id');
        var variantPrice  = parseInt(btn.getAttribute('data-variant-price'), 10);
        var priceStr      = btn.getAttribute('data-variant-price-formatted') || '';
        var available     = btn.getAttribute('data-variant-available') !== 'false';
        var inventory     = parseInt(btn.getAttribute('data-variant-inventory'), 10) || 0;
        var state         = btn.getAttribute('data-variant-state') || 'in';
        var title         = btn.getAttribute('data-variant-title') || '';
        var preorderEta   = btn.getAttribute('data-preorder-eta') || '';

        /* Update active state */
        btns.forEach(function(b) {
          b.classList.remove('mayas-v2-size--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('mayas-v2-size--active');
        btn.setAttribute('aria-pressed', 'true');

        /* Push variant change event for hero (price) + ATC (form) */
        document.dispatchEvent(new CustomEvent('mayas-v2:variant-change', {
          bubbles: true,
          detail: {
            variantId: variantId,
            variant: {
              id: variantId,
              price: variantPrice,
              price_formatted: priceStr,
              available: available,
              inventory_quantity: inventory,
              state: state,
              title: title
            }
          }
        }));

        /* Update stock bar */
        updateStockBar({ available: available, inventory_quantity: inventory, state: state, title: title, preorderEta: preorderEta });

        /* Update URL without reload */
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ----------------------------------------------------------------
     Stock bar update - responds to variant selection
  ---------------------------------------------------------------- */
  function updateStockBar(variant) {
    var bar    = document.getElementById('mayas-v2-stock-bar');
    var fill   = document.getElementById('mayas-v2-stock-fill');
    var status = bar ? bar.querySelector('.mayas-v2-stock-bar__status') : null;
    if (!bar || !fill || !status) return;

    /* Locale strings are bridged in via data-label-* attrs on the stock-bar root,
       populated by Liquid `| t` filters at render time. JS reads the active
       locale's copy without re-implementing translation. */
    var state = variant.state || 'in';
    var pct;
    var label;

    switch (state) {
      case 'remote':
        pct = 100;
        label = bar.getAttribute('data-label-remote') || '';
        break;
      case 'preorder':
        pct = 100;
        label = bar.getAttribute('data-label-preorder') || '';
        break;
      case 'out':
        pct = 0;
        label = bar.getAttribute('data-label-out') || '';
        break;
      case 'low':
        var n = variant.inventory_quantity || 0;
        pct = n * 20;
        label = (bar.getAttribute('data-label-low-template') || '').replace('__N__', n);
        break;
      default:
        pct = 76;
        label = bar.getAttribute('data-label-ready') || '';
    }

    bar.className = 'mayas-v2-stock-bar mayas-v2-stock-bar--' + state;
    fill.style.width = pct + '%';
    status.textContent = label;

    /* Update size label in stock bar */
    var sizeLabel = document.getElementById('mayas-v2-stock-size');
    if (sizeLabel && variant.title) {
      sizeLabel.textContent = variant.title;
    }

    /* Update preorder ETA from variant metafield (mayas.preorder_ship_date,
       pre-formatted in Liquid as "%-d %b" and passed via data-preorder-eta).
       Locale strings come from data-label-preorder-ships-template / -eta on
       the stock-bar root. */
    var etaEl = document.getElementById('mayas-v2-preorder-eta');
    if (etaEl) {
      if (variant.preorderEta) {
        var tmpl = bar.getAttribute('data-label-preorder-ships-template') || '';
        etaEl.textContent = tmpl.replace('__D__', variant.preorderEta);
      } else {
        etaEl.textContent = bar.getAttribute('data-label-preorder-eta') || '';
      }
    }
  }

  function initFindSizeChip() {
    var chip = document.getElementById('mayas-v2-find-size-chip');
    if (!chip) return;
    chip.addEventListener('click', function(e) {
      e.preventDefault();
      /* Wair's app JS injects #wair-fit-advisor; it origin-gates itself
         (400 from its load endpoint on localhost/theme-dev, occasional 400s
         on live), so the button may never appear. Poll 4s, then fall back
         to the size-guide page instead of a silently dead click. */
      var deadline = Date.now() + 4000;
      (function tryOpen() {
        var w = document.getElementById('wair-fit-advisor');
        if (w) { w.click(); return; }
        if (Date.now() < deadline) { window.requestAnimationFrame(tryOpen); return; }
        var g = document.querySelector('.mayas-v2-variants__guide-link');
        if (g && g.getAttribute('href') && g.getAttribute('href') !== '#') window.location.href = g.href;
      })();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSizeGrid();
      initFindSizeChip();
    });
  } else {
    initSizeGrid();
    initFindSizeChip();
  }
})();

/* Back-in-stock notify -> Klaviyo Back in Stock subscription (client API).
   Direct POST to Klaviyo's public /client/ endpoint (company SgwkrS) so the
   capture does NOT depend on klaviyo.js having loaded; the legacy /onsite/
   endpoint is CORS-blocked from the storefront - never use it. Klaviyo's
   Shopify integration watches inventory and fires the Back in Stock flow;
   opens/clicks/conversions live in Klaviyo analytics. */
(function(){
  var COMPANY = 'SgwkrS';
  /* window.fetch on this page is monkey-patched by several third parties
     (Shopify web-pixels, shop_events_listener, RestockRocket, klaviyo.js) and
     the wrapped chain can hard-fail cross-origin POSTs (TypeError before any
     HTTP status). Verified 2026-07-06: wrapped fetch + XHR both die while a
     pristine same-origin iframe fetch returns 202. Fall back to a pristine
     fetch whenever the page's fetch throws at network level. */
  function pristineFetch(url, opts) {
    var ifr = document.createElement('iframe');
    ifr.style.display = 'none';
    document.body.appendChild(ifr);
    var f = ifr.contentWindow && ifr.contentWindow.fetch;
    if (!f) { ifr.remove(); return Promise.reject(new Error('no iframe fetch')); }
    return f.call(ifr.contentWindow, url, opts).finally(function(){ ifr.remove(); });
  }
  function bisFetch(url, opts) {
    return fetch(url, opts).catch(function(){ return pristineFetch(url, opts); });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-notify-btn]');
    if (!btn) return;
    var wrap = btn.closest('.mayas-v2-stock-bar__notify');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="email"]');
    var msg = wrap.querySelector('[data-notify-msg]');
    var email = input ? input.value.trim() : '';
    var active = document.querySelector('.mayas-v2-size--active[data-variant-id]') ||
                 document.querySelector('[data-variant-id][aria-pressed="true"]');
    var variantId = active ? active.getAttribute('data-variant-id') : '';
    function show(text, isError) {
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = false;
      msg.classList.toggle('is-error', !!isError);
    }
    if (!email || email.indexOf('@') < 1) { if (input) input.focus(); return; }
    if (!variantId) return;
    btn.disabled = true;
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }
    };
    bisFetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function(r){
      if (r.status === 202 || r.ok) {
        if (input) input.value = '';
        show(wrap.getAttribute('data-msg-success') || 'OK', false);
      } else {
        return Promise.reject(new Error('BIS status ' + r.status));
      }
    }).catch(function(err){
      btn.disabled = false;
      show(wrap.getAttribute('data-msg-error') || 'Error', true);
      console.warn('[mayas-v2] Klaviyo BIS subscribe failed', err);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
